import { useCallback, useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useNavigate } from "react-router-dom";
import group1 from "../../assets/images/brand/Group1.png";
import group2 from "../../assets/images/brand/Group2.png";
import icon from "../../assets/images/brand/logo_2_107x70.png";
import InputForm from "../../components/InputForm";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import { useUser } from "../../contexts/UserContext";
import {
  useSetUserRegistration,
  useUserRegistration,
} from "../../contexts/UserRegistrationContext";
import { TRegistrationField } from "../../hooks/registration-field-hooks";
import { _axios } from "../../utils/axios";
import uploadFileToBlob from "../../utils/azure-storage-blob";
import { debounce } from "../../utils/common";
import { cookieUtils } from "../../utils/cookieUtils";
import style from "../verificationPage/verifcation.module.css";
import { validateDocuments } from "./VerificationPage.const";
import { fetchAndVerifyUserDetails } from "../../libs/jwtUtils";
const ResubmitForm = () => {
  const [step, setStep] = useState(1);
  const userDetails = useUserRegistration();
  const [documentConfigList, setDocumentConfigList] = useState<any>();
  const [fileTypes, setFileTypes] = useState<Array<string>>([
    "JPG",
    "PNG",
    "GIF",
    "PDF",
  ]);
  const setUserRegistration = useSetUserRegistration();
  const [documentType, setDocumentType] = useState("Adhar Card");
  const [activeUserDetails, setActiveUserDetails] = useState({});
  const [documentId, setDocumentId] = useState(
    userDetails?.gov_id_number ?? ""
  );
  console.log("userDetails", userDetails)
  const [regestrationFields, setRegestrationFields] = useState<any>([]);
  let navigate = useNavigate();
  const user = useUser();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState<any>(() => {
    // const userData = localStorage.getItem('userDetails')
    const userData = cookieUtils.getSecureCookie("userDetails");
    // let user = cookieUtils.getSecureCookie('userDetails');
    console.log("userData", userData)
    const userParsedData = userData ?? {
      name: "",
      email: "",
      mobile_number: "",
    };
    setDocumentType(userDetails?.document_type ?? "Adhar Card");
    return {
      userId: userParsedData.user_id || userDetails?.user_id,
      name: userParsedData?.name,
      email: userParsedData?.email,
      mobile_number: userParsedData?.mobile_number,
      user_salutation: userDetails?.user_salutation,
      user_type: userDetails?.user_type ?? "",
      document_type: userDetails?.document_type,
      gov_id_number: userDetails?.gov_id_number,
      office_address: userDetails?.office_address,
      gov_id_document: '',
      document_certificate: '',
      licence_certificate: '',
      experience_certificate: '',
      email_status: userDetails?.email_status,
      mobile_status: userDetails?.mobile_status,
      regestration_status: userDetails?.regestration_status,
    };
  });

  const convertFileTypeStringToArray = (fileTypesString: string) => {
    // Split the string into an array
    const fileTypesArray = fileTypesString.split(",");

    // Capitalize each element of the array
    const capitalizedFileTypesArray = fileTypesArray.map((fileType) =>
      fileType.toUpperCase()
    );

    return capitalizedFileTypesArray;
  };



  const fetchAndSetFormConfiguration = async () => {
    const userData = cookieUtils.getSecureCookie("userDetails");
    // 1️⃣ Fetch, Validate & Decode User Token
    let userDetailsResponse = await fetchAndVerifyUserDetails(userData?.user_id ?? "", true);

    console.log("User Details Response:", userDetailsResponse);
    const currentUser = userDetailsResponse?.data?.data;

    if (currentUser && Object.keys(currentUser)?.length !== 0) {
      setDocumentType(currentUser?.document_type ?? "Adhar Card");
      setFormData((prevState: any) => ({
        ...prevState,
        userId: currentUser?.user_id,
        name: currentUser?.name,
        email: currentUser?.email,
        mobile_number: currentUser?.mobile_number,
        user_salutation: userDetails?.user_salutation,
        user_type: currentUser?.user_type ?? "",
        document_type: currentUser?.document_type,
        gov_id_number: currentUser?.gov_id_number,
        office_address: currentUser?.office_address,
        gov_id_document: '',
        document_certificate: '',
        licence_certificate: '',
        experience_certificate: '',
        email_status: currentUser?.email_status,
        mobile_status: currentUser?.mobile_status,
        regestration_status: currentUser?.regestration_status,
      }));
    }
  }

  const getDocumentConfig = () => {
    _axios
      .get(`${BASE_URL}/api/document-config/regestration`)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setDocumentConfigList(response.data.data[0]);
        setFileTypes(
          convertFileTypeStringToArray(response.data.data[0].file_type)
        );

        // handle success
        console.log("setDocumentConfigList", response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  };

  const getRegistrationFields = () => {
    _axios
      .post(`${BASE_URL}/api/registration-fields`, {
        page: 1,
        limit: 10,
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setRegestrationFields(response.data.data);

        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  };

  useEffect(() => {
    getRegistrationFields();
    getDocumentConfig();
    fetchAndSetFormConfiguration();
  }, []);

  const handleNext = async () => {
    if (step === 1) {
      const adharCardRegex =
        /^([1-9][0-9]{3}[0-9]{4}[0-9]{4})|([1-9][0-9]{3}\s[0-9]{4}\s[0-9]{4})|([1-9][0-9]{3}-[0-9]{4}-[0-9]{4})$/;
      const drivingLicenceRegex =
        /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/gm;
      const panCardRegex = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
      const voterCardRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
      const passportRegex = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
      if (!formData.user_type) {
        return ErrorToast("Please select a user type");
      }
      if (documentType === "Adhar Card") {
        const isValid = adharCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast(
            "Ensure that you have entered the correct 12-digit Aadhaar number"
          );
          return;
        }
      } else if (documentType === "Driving Licence") {
        const isValid = drivingLicenceRegex.test(documentId);
        if (!isValid) {
          ErrorToast(
            "Be sure to include any letters, numbers, or spaces as they appear on your physical license"
          );
          return;
        }
      } else if (documentType === "Pan Card") {
        const isValid = panCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast(
            "Ensure that you have entered the correct 10-character alphanumeric PAN number.eg(XXXXX0000X"
          );
          return;
        }
      } else if (documentType === "Voter Card") {
        const isValid = voterCardRegex.test(documentId);
        if (!isValid) {
          ErrorToast(
            "Ensure that you have entered the correct Voter ID number. Voter ID numbers can vary in length and format"
          );
          return;
        }
      } else if (documentType === "Passport") {
        const isValid = passportRegex.test(documentId);
        if (!isValid) {
          ErrorToast(
            "Ensure that you have entered the correct passport number. Passport numbers typically include both letters and numbers."
          );
          return;
        }
      }
      let filtredList = regestrationFields?.filter(
        (field: any) => field?.mandatory == 1
      );
      if (filtredList?.length > 0) {
        let index = filtredList.map((list: any) => list.registration_field_id);
        if (index.includes(7) && formData?.office_address.length < 1) {
          ErrorToast("Please enter valid address");
          return;
        }
      }
      setStep(step + 1);
    } else if (step === 2) {
      if (!documentConfigList?.file_size) {
        ErrorToast(
          `Document Config for Registration Document is not Configured by the Admin`
        );
      } else {
        const validRes = validateDocuments(
          documentConfigList,
          formData,
          formData.user_type
        );
        if (validRes.valid) {
          debouncedHandleNext();
        } else ErrorToast(validRes.message);
      }
    }
  };

  const handleSubmit = async () => {
    if (!documentConfigList?.file_size) {
      return ErrorToast(
        `Document Config for Registration Document is not Configured by the Admin`
      );
    }
    const validRes = validateDocuments(
      documentConfigList,
      formData,
      formData.user_type
    );
    if (!validRes.valid) {
      ErrorToast(validRes.message);
    } else {
      setIsSubmitting(true);
      const experience_certificate = formData?.experience_certificate
        ? await uploadFileToBlob(
          formData.experience_certificate,
          "experience_certificate",
          "user_details",
          user?.user_id ?? ""
        )
        : null;
      const gov_id_document = formData.gov_id_document?.name
        ? await uploadFileToBlob(
          formData.gov_id_document,
          "gov_id_document",
          "user_details",
          user?.user_id ?? ""
        )
        : formData.gov_id_document;
      const document_certificate = formData.document_certificate?.name
        ? await uploadFileToBlob(
          formData.document_certificate,
          "document_certificate",
          "user_details",
          user?.user_id ?? ""
        )
        : formData.document_certificate;
      const licence_certificate = formData.licence_certificate?.name
        ? await uploadFileToBlob(
          formData.licence_certificate,
          "licence_certificate",
          "user_details",
          user?.user_id ?? ""
        )
        : formData.licence_certificate;
      console.log(userDetails);
      _axios
        .patch(`${BASE_URL}/api/user-details`, {
          user_id: formData.userId || userDetails?.user_id,
          name: formData?.name,
          email: formData?.email,
          mobile_number: formData?.mobile_number,
          user_salutation: formData?.user_salutation,
          user_type: formData?.user_type,
          document_type: formData?.document_type,
          gov_id_number: formData?.gov_id_number,
          office_address: formData?.office_address,
          gov_id_document: gov_id_document,
          document_certificate: document_certificate,
          licence_certificate: licence_certificate,
          experience_certificate,
          email_status: formData?.email_status,
          mobile_status: formData?.mobile_status,
          regestration_status: 0,
        })
        .then(function (response) {
          console.log("response", response);
          setIsSubmitting(false);
          setUserRegistration({ ...userDetails, ...formData });
          _axios
            .post(`${BASE_URL}/api/user-verification-comments`, {
              user_id: formData.userId || userDetails?.user_id,
              name: formData.name || userDetails?.name,
              email: formData.email || userDetails?.email,
              comment: "Registration request is currently under review.",
              comments_by: "user",
              status: 0,
            })
            .then(function (response) {
              navigate("/user-account-not-verified");
              SuccessToast("Submitted successfully");
            })
            .catch(function (error) {
              // handle error
              console.log(error);
              setIsSubmitting(false);
            });
        })
        .catch(function (error) {
          // handle error
          setIsSubmitting(false);
          console.log(error);
        });
    }
  };
  const userTypeField = regestrationFields?.find(
    (field: any) =>
      field?.uid === "user_type" && field?.active && field?.options?.length
  );
  const debouncedHandleNext = useCallback(debounce(handleSubmit, 3000), [
    formData,
    formData.gov_id_document?.name,
    formData.document_certificate?.name,
    formData.licence_certificate?.name,
    documentConfigList,
    user,
    userDetails,
  ]);

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };
  // console.log('userData', JSON.parse(userData as string))


  console.log("activeForm", formData);
  return (
    <div className={style.pageContainer}>
      <div className={style.formPage}>
        <div className={style.logo}>
          <img src={icon} alt="Logo" style={{ display: "inline" }} />
          {/* <h5 className={style.mainHeading} >Verification</h5> */}
        </div>
        {/* Step indicator */}

        {/* Your existing form */}
        {step === 1 && (
          <>
            <h5 className={style.mainHeading}>Verification</h5>

            <div className={style.verificationContainer}>
              {/* <br /> */}
              <img src={group1} alt="Logo" className={style.groupLogo} />
              <br />
              <h5 className={style.semiHeading}>Personal Details</h5>
              <div className={style.inputGroup}>
                {regestrationFields?.find(
                  (field: any) =>
                    field?.registration_field_id == 1 && field?.active == 1
                ) && (
                    <div className={style.inputField}>
                      <InputForm
                        title={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 1
                          )?.label_name
                        }
                        isRequired={
                          regestrationFields?.find(
                            (field: any) =>
                              field?.registration_field_id == 1 &&
                              field?.mandatory == 1
                          )
                            ? true
                            : false
                        }
                        isIcon={true}
                        icon={"fa fa-user-o"}
                        placeholder={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 1
                          )?.placeholder_name ?? "Full Name"
                        }
                        type="text"
                        isName={true}
                        disabled
                        value={formData.name}
                        sufixValue={formData.user_salutation}
                        onSuffixChange={(event) => {
                          setFormData({
                            ...formData,
                            user_salutation: event.target.value,
                          });
                        }}
                      />
                    </div>
                  )}

                {regestrationFields?.find(
                  (field: any) =>
                    field?.registration_field_id == 2 && field?.active == 1
                ) && (
                    <div className={style.inputField}>
                      <InputForm
                        title={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 2
                          )?.label_name
                        }
                        isRequired={
                          regestrationFields?.find(
                            (field: any) =>
                              field?.registration_field_id == 2 &&
                              field?.mandatory == 1
                          )
                            ? true
                            : false
                        }
                        isIcon={true}
                        icon={"fa fa-envelope-o"}
                        placeholder={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 2
                          )?.placeholder_name ?? "Email"
                        }
                        type="email"
                        disabled
                        value={formData.email}
                      />
                    </div>
                  )}
              </div>

              <div className={style.inputGroup}>
                {regestrationFields?.find(
                  (field: any) =>
                    field?.registration_field_id == 3 && field?.active == 1
                ) && (
                    <div className={style.inputField}>
                      <InputForm
                        title={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 3
                          )?.label_name
                        }
                        isRequired={
                          regestrationFields?.find(
                            (field: any) =>
                              field?.registration_field_id == 3 &&
                              field?.mandatory == 1
                          )
                            ? true
                            : false
                        }
                        isIcon={true}
                        icon={"fa fa-mobile-phone fa-lg"}
                        placeholder={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 3
                          )?.placeholder_name ?? "Mobile Number"
                        }
                        type="tel"
                        disabled
                        value={formData.mobile_number}
                      />
                    </div>
                  )}

                {!!userTypeField && (
                  <div className={style.inputField}>
                    <legend className={style.legendTag}>
                      {userTypeField?.label_name || "User Type"}
                      {!!userTypeField?.mandatory && (
                        <span className="text-red-500">{" *"}</span>
                      )}
                    </legend>
                    <select
                      id="role"
                      name="role"
                      className={style.dropdownMenu}
                      value={formData.user_type}
                      onChange={(e) => {
                        setFormData({ ...formData, user_type: e.target.value });
                      }}
                    >
                      <option disabled hidden value={""}></option>
                      {userTypeField?.options
                        ?.filter(
                          (
                            e: NonNullable<
                              TRegistrationField["options"]
                            >[number]
                          ) => !!e?.active
                        )
                        ?.map(
                          (
                            opt: NonNullable<
                              TRegistrationField["options"]
                            >[number]
                          ) => (
                            <option key={opt?.id || opt.name} value={opt.name}>
                              {opt.name}
                            </option>
                          )
                        )}
                    </select>
                  </div>
                )}
              </div>
              <div className={style.inputGroup}>
                {regestrationFields?.find(
                  (field: any) =>
                    field?.registration_field_id == 5 && field?.active == 1
                ) && (
                    <div className={style.inputField}>
                      <legend className={style.legendTag}>
                        {
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 5
                          )?.label_name
                        }{" "}
                        {regestrationFields?.find(
                          (field: any) =>
                            field?.registration_field_id == 5 &&
                            field?.mandatory == 1
                        ) && <span className="text-red-500">{" *"}</span>}
                      </legend>
                      <select
                        id="role"
                        name="role"
                        value={formData.document_type}
                        className={style.dropdownMenu}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            document_type: e.target.value,
                          });
                          setDocumentType(e.target.value);
                        }}
                      >
                        <option value="Adhar Card">Adhar Card</option>
                        <option value="Driving Licence">Driving Licence</option>
                        <option value="Pan Card">Pan Card</option>
                        <option value="Voter Card">Voter Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                    </div>
                  )}
                {regestrationFields?.find(
                  (field: any) =>
                    field?.registration_field_id == 6 && field?.active == 1
                ) && (
                    <div className={style.inputField}>
                      <InputForm
                        title={documentType}
                        isRequired={
                          regestrationFields?.find(
                            (field: any) =>
                              field?.registration_field_id == 6 &&
                              field?.mandatory == 1
                          )
                            ? true
                            : false
                        }
                        isIcon={true}
                        icon={"fa fa-credit-card"}
                        placeholder={
                          regestrationFields?.find(
                            (field: any) => field?.registration_field_id == 6
                          )?.placeholder_name ?? "Enter Number"
                        }
                        type="text"
                        value={formData.gov_id_number}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            gov_id_number: e.target.value,
                          });
                          setDocumentId(e.target.value);
                        }}
                      />
                    </div>
                  )}
              </div>

              {regestrationFields?.find(
                (field: any) =>
                  field?.registration_field_id == 7 && field?.active == 1
              ) && (
                  <div className={style.inputField}>
                    <p className={style.officeLabel}>
                      {" "}
                      {
                        regestrationFields?.find(
                          (field: any) => field?.registration_field_id == 7
                        )?.label_name
                      }
                      {regestrationFields?.find(
                        (field: any) =>
                          field?.registration_field_id == 7 &&
                          field?.mandatory == 1
                      ) && <span className="text-red-500">{" *"}</span>}{" "}
                    </p>
                    <textarea
                      value={formData.office_address}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(
                          /[^a-zA-Z0-9\s-/]/g,
                          ""
                        );
                        setFormData({
                          ...formData,
                          office_address: sanitizedValue,
                        });
                      }}
                      placeholder={
                        regestrationFields?.find(
                          (field: any) => field?.registration_field_id == 7
                        )?.placeholder_name ?? "Enter Office Address"
                      }
                      required
                    ></textarea>
                    {/* <textarea
                                    value={formData.office_address}
                                    onChange={(e) => { setFormData({ ...formData, office_address: e.target.value }) }}
                                    placeholder={regestrationFields?.find((field: any) => field?.registration_field_id == 7)?.placeholder_name ?? "Enter Office Address"}
                                    required
                                ></textarea> */}
                  </div>
                )}
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <h5 className={style.mainHeading}>Verification</h5>

            <img src={group2} alt="Logo" className={style.groupLogo} />
            <h5 className={style.semiHeading}>Upload Documents</h5>
            <span className={style.browseLabel}> {documentType} </span>
            <div className={style.uploadSection}>
              <FileUploader
                handleChange={(value: any) => {
                  setFormData({ ...formData, gov_id_document: value });
                }}
                name="file"
                types={fileTypes}
                children={
                  <div className={style.uploadContainerDocument}>
                    <label className={style.uploadLable}>Browse</label>
                    <p className={`${style.linkCss} md:w-full lg:w-full`}>
                      {formData?.gov_id_document?.name ||
                        formData?.gov_id_document ||
                        "Drag and drop file here"}
                    </p>
                  </div>
                }
              />
            </div>
            {formData?.user_type === "Architect" && (
              <>
                <p className={style.browseLabel}> Degree Certificate </p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, document_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate
                            ? formData?.document_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
                <p className={style.browseLabel}>
                  Architect License Certificate *
                </p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, licence_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.licence_certificate
                            ? formData?.licence_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}
            {formData?.user_type === "Engineer" && (
              <>
                <p className={style.browseLabel}> Degree Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, document_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate
                            ? formData?.document_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>

                <p className={style.browseLabel}>
                  Engineer License Certificate *
                </p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, licence_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.licence_certificate
                            ? formData?.licence_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}
            {formData?.user_type === "Supervisor" && (
              <>
                <p className={style.browseLabel}>
                  {" "}
                  Highest Education Certificate *
                </p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, document_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.document_certificate
                            ? formData?.document_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>

                <p className={style.browseLabel}>Experience Certificate *</p>
                <div className={style.uploadSection}>
                  <FileUploader
                    handleChange={(e: any) => {
                      setFormData({ ...formData, experience_certificate: e });
                    }}
                    name="file"
                    types={fileTypes}
                    children={
                      <div className={style.uploadContainerDocument}>
                        <label className={style.uploadLable}>Browse</label>
                        <p className={`${style.linkCss} md:w-full lg:w-full`}>
                          {formData?.experience_certificate
                            ? formData?.experience_certificate?.name
                            : "Drag and drop file here"}
                        </p>
                      </div>
                    }
                  />
                </div>
              </>
            )}
          </>
        )}
        <>
          {step !== 1 && (
            <button className={style.blackBtn} onClick={handleBack}>
              Back
            </button>
          )}
          <button
            className={style.yellowBtn}
            onClick={handleNext}
            disabled={isSubmitting}
          >
            {step === 2 ? (isSubmitting ? "Submitting..." : "Submit") : "Next"}
          </button>
        </>
      </div>
    </div>
  );
};

export default ResubmitForm;
